import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';

import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Table } from "antd";
import { BeatLoader } from 'react-spinners';
// import Pagination from '../../Pagination';
import Skeleton from 'react-loading-skeleton'
import { Tooltip } from 'antd';
// import {adminMainUrl} from '../../../../Config'
// import AddMaster from "./AddMaster";
// import EditMaster from "./EditMaster";
// import { adminMainUrl } from '../../../../Config';
// import { DesignationApi } from '../../../../Redux/action/MasterAction';

const Search = ({ accessedModules, accessedPermission }) => {

const columns = [
{ title: "Title", dataIndex: "currencyName", key: "currencyName" },
{ title: "Location", dataIndex: "code", key: "code" },
{ title: "Submitted On", dataIndex: "forExport", key: "forExport" },
{ title: "Status", dataIndex: "forImport", key: "forImport" },

];

const data = [
{
key: "1",
currencyName: "US Dollar",
code: "USD",

},
];

return (
<>
    <div className="page-wrapper">
        <div className="content">
            <div className="row">
                <div className="col-md-12">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">
                                    KB Search<span className="count-title">3</span>
                                </h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    <a href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top"
                                        data-bs-original-title="Collapse" id="collapse-header">
                                        <i className="ti ti-chevrons-up" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}
                </div>
            </div>
            <div className="card">

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">

                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0">Look For</label>
                                <div className="icon-forms mb-3">
                                    <input type="text" id="effectiveFrom" className="form-control form-control-sm" />
                                </div>
                            </div>

                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="effectiveFrom" className="form-label mb-0">Title</label>
                                <div className="icon-forms mb-3">
                                    <input type="text" id="effectiveFrom" className="form-control form-control-sm" />
                                </div>
                            </div>
                            <div className="col-md-12 d-grid"
                                style={{ gridTemplateColumns: "1fr 5fr", display: "grid" }}>
                                <label htmlFor="searchFor" className="form-label mb-0">Look In</label>
                                <div className="icon-forms mb-3 d-flex flex-row gap-1">
                                    <select id="quickSearch" className="form-control form-control-sm">
                                        <option value="inName">All</option>
                                        <option value="inID">2</option>
                                    </select>
                                    <button className="btn btn-primary text-xs" type="submit">
        Search
    </button>
                                </div>
                            </div>
                            <div className="col-md-12 d-grid" style={{
    gridTemplateColumns: "1fr 5fr",
    display: "grid",
    height: "250px",
    overflowY: "scroll",
  }}>
                                {/* Search results content goes here */}
                            </div>

                        </div>
                        <div className="col-md-6 d-flex flex-column justify-content-end ">

                            <p className='ps-2'
                                style={{ backgroundColor: '#F3EDFF', color: '#4A00E5', fontSize: '16px' }}>
                                Attachment:
                            </p>

                        </div>

                    </div>

                    {/* Filter */}

                    {/* /Filter */}

                    {/* Contact List */}

                    {/* {
                    loadingDesignationTypeApi ?
                    arr.map((value, index) => {
                    return (

                    <div className='d-flex justify-content-center align-items-center'
                        style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                    </div>
                    )
                    }) :
                    spinnerLoader ?
                    <>
                        <div className='d-flex justify-content-center align-items-center'
                            style={{ height: "400px", width: "100%" }}>
                            <BeatLoader />
                        </div>
                    </> :
                    <> */}

                        {/*
                        <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset}
                            dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount}
                            setCurrentData={setCurrentData} currentData={currentData} />
                    </>
                    } */}
                    {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                        <button className='' onClick={()=> handlePageChange(count - 1)}
                            disabled={count === 1}
                            >
                            <img src="/img/right.png" className='mx-2' alt="right" />
                        </button>

                        {pageNumbers.map((number, index) =>
                        number === '...' ? (
                        <span key={index} className="mx-2">...</span>
                        ) : (
                        <span key={number} className={`search-btn-1 ${number===count ? 'active' : '' }`} onClick={()=>
                            handlePageChange(number)}
                            style={{ cursor: 'pointer' }}
                            >
                            {number}
                        </span>
                        )
                        )}

                        <button onClick={()=> handlePageChange(count + 1)}
                            disabled={count === totalPages}
                            >
                            <img src="/img/left.png" className='mx-2' alt="right" />
                        </button>
                    </div> */}
                </div>
            </div>
        </div>
    </div>
    {/*
    <AddMaster show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} />
    <EditMaster show={editshow} handleClose={handleEditClose} onSuccess={handleSuccess} /> */}
    {/*
    <EditEmployee id="offcanvas_edit" />
    <AddEmployee id="offcanvas_add" /> */}
    {/*
    <CreateQuoteForm SentQuoteList={SentQuoteList} id="offcanvas_create" />
    <EditQuoteForm id="offcanvas_edit_form" QuotationId={id} ViewDetails={viewData} /> */}
</>

)
}

export default Search